import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the EllipsesTextPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'ellipsesText',
})
export class EllipsesTextPipe implements PipeTransform {
  transform(value: string, maxLength) {
    if (String(value || '').length > maxLength) {
      return (
        String(value)
          .slice(0, maxLength - 3)
          .trim()
          .replace(/\.+$/, '') + '...'
      );
    }
    return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/ellipses-text/ellipses-text.ts